exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.footer[data-v-6588ebb5] {\n  font-size: 12px;\n  color: #cccccc;\n}\n.content[data-v-6588ebb5] {\n  background: white;\n}\n", ""]);
